import { render } from "./LayoutEs.vue?vue&type=template&id=70db7e1e"
import script from "./LayoutEs.vue?vue&type=script&lang=js"
export * from "./LayoutEs.vue?vue&type=script&lang=js"

import "./LayoutEs.vue?vue&type=style&index=0&id=70db7e1e&lang=css&scope=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__